import { useDateFormat } from '@vueuse/core'
import { toValue } from 'vue'

const US_DATE_FORMAT = 'MM-DD-YYYY HH:mm:ss'

/**
 * Formats a date to a specific format
 * @see https://vueuse.org/shared/useDateFormat/
 *
 * @param {Date|string|Ref<string>} date The date to be formatted
 * @param {string} format The format string, inspired by dayjs
 * @returns {string} The formatted date
 */
export const formatDate = (date, format = US_DATE_FORMAT) => toValue(useDateFormat(date, format))
